{
  "title": "Augury",
  "source": "Player's Handbook",
  "levelAndSchool": "2nd-level divination (ritual)",
  "level": 2,
  "castingTime": "1 minute",
  "range": "Self",
  "components": "V, S, M (specially marked sticks, bones, or similar tokens worth at least 25 gp)",
  "duration": "Instantaneous",
  "description": [
    "By casting gem-inlaid sticks, rolling dragon bones, laying out ornate cards, or employing some other divining tool, you receive an omen from an otherworldly entity about the results of a specific course of action that you plan to take within the next 30 minutes. The DM chooses from the following possible omens:",
    "Weal, for good results",
    "Woe, for bad results",
    "Weal and woe, for both good and bad results",
    "Nothing, for results that aren’t especially good or bad",
    "The spell doesn’t take into account any possible circumstances that might change the outcome, such as the casting of additional spells or the loss or gain of a companion. If you cast the spell two or more times before completing your next long rest, there is a cumulative 25 percent chance for each casting after the first that you get a random reading. The DM makes this roll in secret."
  ],
  "spellLists": ["cleric", "druid", "wizard"]
}
